import React from 'react'
import '../styles/routeFilter.css'

interface RouteFilterProps {
    routes: string[]
    selectedRoute: string
    onRouteChange: (route: string) => void
    loading: boolean
}

function RouteFilter({
    routes,
    selectedRoute,
    onRouteChange,
    loading
}: RouteFilterProps) {
    return (
        <div className='route_filter_container'>
            <div className='route_filter_item'>
                <label htmlFor='route_select'>Rota:</label>
                <select
                    id='route_select'
                    value={selectedRoute}
                    onChange={(e) => onRouteChange(e.target.value)}
                    disabled={loading || routes.length === 0}
                    className='route_select'
                >
                    <option value='TODOS'>Todas as Rotas</option>
                    {routes.map((route) => (
                        <option key={route} value={route}>
                            {route}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}

export default RouteFilter
